import { libFormatDate } from 'src/toolkit';


export function getBirthdayHelper(date: string, born: string, year: string, months: string[]): string {
	const dateString = libFormatDate(date, { template: 'dd MM yyyy', months });

	return `${born} ${dateString.toLowerCase()} ${year}`;
}
